import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { ProtectedRoleResourceManager } from "../hooks/roles/ProtectedRoleResourceManager";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
const ErrorPage = React.lazy(() => import("../components/error-page"));
const TareaDetalleMasInfoRM = React.lazy(
  () =>
    import("../components/task/resultManager/tareaDetalleMasInfoRM/tarea-detalle-mas-info-rm"),
);
export function tareaDetalleMasInfoRM() {
  return (
    <Route
      path="/tarea-detalle-mas-info-rm"
      element={
        <LazySuspense>
          {" "}
          <ProtectedRoute>
            <ProtectedRoleResourceManager>
              <LazySuspense>
                <TareaDetalleMasInfoRM />
              </LazySuspense>
            </ProtectedRoleResourceManager>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
